import React from 'react';
import { Navigation } from '../components/Navigation';
import { HeroSection } from '../components/HeroSection';
import { AboutSection } from '../components/AboutSection';
import { CredentialsSection } from '../components/CredentialsSection';
import { SpecialtySection } from '../components/SpecialtySection';
import { PortfolioCarousel } from '../components/PortfolioCarousel';
import { ProcessSection } from '../components/ProcessSection';
import { TestimonialsCarousel } from '../components/TestimonialsCarousel';
import { CTASection } from '../components/CTASection';
import { FAQSection } from '../components/FAQSection';
import { Footer } from '../components/Footer';
import { LanguageGate } from '../components/LanguageGate';
export function LandingPage() {
  return <div className="min-h-screen bg-brand-black text-brand-white font-sans" data-id="element-229">
      <LanguageGate data-id="element-230">
        <Navigation data-id="element-231" />
        <main data-id="element-232">
          <div id="hero" data-id="element-233">
            <HeroSection data-id="element-234" />
          </div>
          <div id="about" data-id="element-235">
            <AboutSection data-id="element-236" />
          </div>
          <div id="portfolio" data-id="element-237">
            <PortfolioCarousel data-id="element-238" />
          </div>
          <div id="credentials" data-id="element-239">
            <CredentialsSection data-id="element-240" />
          </div>
          <div id="specialty" data-id="element-241">
            <SpecialtySection data-id="element-242" />
          </div>
          <div id="process" data-id="element-243">
            <ProcessSection data-id="element-244" />
          </div>
          <div id="testimonials" data-id="element-245">
            <TestimonialsCarousel data-id="element-246" />
          </div>
          <div id="faq" data-id="element-247">
            <FAQSection data-id="element-248" />
          </div>
          <div id="contact" data-id="element-249">
            <CTASection data-id="element-250" />
          </div>
        </main>
        <Footer data-id="element-251" />
      </LanguageGate>
    </div>;
}